export default "__VITE_ASSET__CO$uuLUu__"